import { TranslationKeys } from '../types';
import { pt } from './pt/index';

const ptTranslations: TranslationKeys = pt;

export default ptTranslations;
